import { EntryListContent } from '@/api/interfaces/content/common/entryListContent';

export const messagesContent: EntryListContent = {
    admin: {
        exportError: 'Exportieren fehlgeschlagen.',
        exportGenerateCsvError:
            'Generieren der Export-CSV-Datei fehlgeschlagen.',
        getAdminApplicationsError:
            'Ein Fehler ist aufgetreten. Die Anträge konnten nicht geladen werden.',
        migrateApplicantError: 'Umziehen des Antragsstellers fehlgeschlagen.',
        migrateApplicantRequirementsUnfulfilled:
            'Keine Anträge ausgewählt, oder Id des Ziel-Antragsstellers ungültig.',
        migrateApplicantSuccess: 'Antragssteller erfolgreich umgezogen.',
    },
    applications: {
        copied: 'Der Antrag wurde erfolgreich kopiert.',
        deleted: 'Der Antrag wurde erfolgreich gelöscht.',
        deleteError:
            'Ein Fehler ist aufgetreten. Der Antrag wurde nicht gelöscht.',
        documents: {
            fileExtensionNotFoundError:
                'Die ausgewählte Datei hat keinen Dateityp definiert, oder er konnte nicht extrahiert werden.',
            newFileNameCreationError:
                'Erstellung eines neuen Dateinamen fehlgeschlagen.',
        },
        getDataError:
            'Ein Fehler ist aufgetreten. Der Antrag konnte nicht geladen werden.',
        getUserApplicationsError:
            'Ein Fehler ist aufgetreten. Die Anträge konnten nicht geladen werden.',
        lastModifiedMismatch:
            'Der Antrag wurde im Hintergrund bearbeitet. Um Datenkonflikte zu vermeiden, können die aktuellen Änderungen nicht gespeichert werden. Bitte achten Sie darauf, dass der Antrag nicht gleichzeitig bearbeitet wird. Um weiterzumachen, laden Sie die Seite neu.',
        notFound: 'Der Antrag konnte nicht gefunden werden.',
        saveError:
            'Ein technischer Fehler ist aufgetreten, bitte versuchen Sie es erneut.',
        splitError:
            'Ein technischer Fehler ist aufgetreten, bitte versuchen Sie es erneut.',
        stepCompensationError:
            'Es ist ein technischer Fehler aufgetreten. Beim Versuch einen älteren Stand wiederherzustellen ist ebenfalls ein technischer Fehler aufgetreten. Ein Mitarbeiter wird Ihren Antrag manuell prüfen, wir bitten um Ihr Verständnis.',
    },
    external: {
        addresses: {
            authorizationFailed:
                'Es ist ein internes Problem bei der Nutzung unseres Address-Service aufgetreten, bitte versuchen Sie es erneut.',
            badSuccess: 'Bitte versuchen Sie es mit gültigen Eingaben erneut.',
            serviceUnavailable:
                'Der Address-Service ist derzeit, für gewöhnlich aufgrund von Wartung, nicht erreichbar. Bitte versuchen Sie es später erneut.',
        },
        vss: {
            resultNotClean:
                'Leider gibt es ein Problem mit diesem Dokument. Bitte überprüfen Sie das Dokument.',
        },
    },
    fatalError:
        'Ein technischer Fehler ist aufgetreten, bitte versuchen Sie es erneut.',
    tools: {
        bakeApplicationSummariesError:
            'Ein Fehler ist aufgetreten. Die Dokumente konnten nicht gebacken werden.',
        deleteBakedApplicationSummariesError:
            'Ein Fehler ist aufgetreten. Die gebackenen Dokumente wurden nicht gelöscht.',
        getApplicationsWithoutBakedSummaryError:
            'Ein Fehler ist aufgetreten. Die Anträge ohne gebackenen Dokumente konnten nicht geladen werden.',
    },
    unauthorized:
        'Sie sind nicht berechtigt, die angeforderte Seite aufzurufen.',
};
